import { Controller } from "@hotwired/stimulus";

const TEASER_MAX = 250;

export default class extends Controller {
  static targets = ["title", "slugPreview", "teaser", "counter"];

  connect() {
    this.#updateCounter();
  }

  updateSlug() {
    this.slugPreviewTarget.textContent = this.#slugify(this.titleTarget.value);
  }

  updateCounter() {
    this.#updateCounter();
  }

  #updateCounter() {
    const len = this.teaserTarget.value.length;
    this.counterTarget.textContent = `${len} / ${TEASER_MAX}`;
    this.counterTarget.classList.toggle("text-danger", len > TEASER_MAX);
  }

  #slugify(str) {
    return str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }
}
